import { createSelector } from 'reselect';
import Empty from 'constants/empty';

// Raw selectors: no transforms, no allocations of new literals each call.
// Use shared Empty constants for stable references.
const saveForLaterStateSelector = state => state.saveForLater || Empty.Object;
const saveForLaterListsSelector = state => state.saveForLater?.lists || Empty.Array;
const saveForLaterListIdSelector = state => state.saveForLater?.listId || null;
const saveForLaterItemsSelector = state => state.saveForLater?.items || Empty.Array;
const saveForLaterLoadingSelector = state => !!state.saveForLater?.loading;
const saveForLaterErrorSelector = state => state.saveForLater?.error || null;

/**
 * Memoized selector to create a Set of saved SKU IDs for O(1) lookup.
 * Only recomputes when items array changes.
 */
const savedSkuIdsSetSelector = createSelector(saveForLaterItemsSelector, items => {
    if (!items || items.length === 0) {
        return new Set();
    }

    const skuIds = items.map(item => item.skuId || item.sku?.skuId).filter(Boolean);

    return new Set(skuIds);
});

export {
    saveForLaterStateSelector,
    saveForLaterListsSelector,
    saveForLaterListIdSelector,
    saveForLaterItemsSelector,
    saveForLaterLoadingSelector,
    saveForLaterErrorSelector,
    savedSkuIdsSetSelector
};
